import { z } from "zod";
import { useQueryState } from "~/lib/hooks/useQueryState";

export const SortOptions = {
	Newest: "nyeste",
	Oldest: "eldste",
} as const;

export type SortOptions = (typeof SortOptions)[keyof typeof SortOptions];
export const sortOptionSchema = z.enum([SortOptions.Newest, SortOptions.Oldest]);

export const useArticleFilters = () => {
	const [sort, setSort] = useQueryState<SortOptions>("sort", SortOptions.Newest);

	return {
		sort,
		setSort,
	};
};
